// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { Resources } from '@shared/localizations/Resources';
export class _TvExchangesManger {
    constructor() {
        this.AllExchanges = 'all';
    }
    getExchanges() {
        const exchanges = DataCache.NonFixedList
            ? DataCache.EntitlementManager.GetSubscribedExchanges()
            : DataCache.TradingExchanges;
        if (DataCache.NonFixedList) {
            return [];
        }
        exchanges.sort((a, b) => a.localeCompare(b));
        const tvExchanges = [];
        const allExchange = {
            name: Resources.getResource('ExchangeId.All'),
            value: this.AllExchanges,
            desc: ''
        };
        tvExchanges.push(allExchange);
        for (const exchange of exchanges) {
            const tvExchange = {
                value: exchange,
                name: exchange,
                desc: '' // exchange
            };
            tvExchanges.push(tvExchange);
        }
        return tvExchanges;
    }
}
export const TvExchangesManger = new _TvExchangesManger();
